import { SearchTarget } from "../enums/SearchTarget";
import { QueryType } from "../enums/QueryType";
import { CommonFunctions } from "../static/common-functions";

export class CommonParam
{
    userId: any;
    companyId: any;
    customerId: any;
    locationId: any;
    createdBy: any;
    searchTarget: SearchTarget = SearchTarget.any;
    search: string;
    custom: boolean = false;
    active: boolean = true;
    serviceType: number = 0;  //0-any,1-service,2-construction
    startDate: any;
    endDate: any;
    dcParams: any;
    skip: number;
    take: number;
    includeRetired: boolean = false;
    isWarranty: any;
    get hasParams(): boolean {
        return CommonFunctions.hasValue(this.dcParams);
    }
    //addParams(params: CommonParam) {
    //    if (params && CommonFunctions.hasArrayElementValue(params.dcParams)) {
    //        for (let i = 0; i < params.dcParams.length; i++) {
    //            this.addParam(params.dcParams[0])
    //        }
    //    }
    //}
    addParam(key: string, value: any) {
        if (!this.hasParams) {
            this.dcParams = new Object();
        }
        this.dcParams[key] = value;
    }
    getParam(key: string) {
        let retVal: any = null;
        if (this.hasParams) {
            retVal = this.dcParams[key];
        }
        return retVal;
    }
    clearCustom() {
        this.customerId = undefined;
        this.locationId = undefined;
        this.search = "";
        this.createdBy = undefined;
        this.startDate = undefined;
        this.endDate = undefined;
        this.dcParams = new Object();
    }
}
